export default __webpack_public_path__ + "static/group-dont-3341538073753d4625f728a71bee9192.png";